import { ApiType } from "@gymflow/common";
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from "@tanstack/react-query";

import { apiV2 } from "../../apiV2";
import { memberQueryKeys } from "../member";
import { reportQueryKeys } from "../report";
import { leadQueryKeys } from "./leadQueryKeys";

export function useMutationLeadStatus(
  {
    api,
  }: {
    api: ApiType;
  },
  mutationOpts?: UseMutationOptions<
    { leadId: number; newStatusId: number },
    unknown,
    { leadId: number; newColumn: number }
  >,
) {
  const queryClient = useQueryClient();

  const changeLeadStatusMutation = useMutation({
    mutationFn: async ({
      leadId,
      newColumn,
    }: {
      leadId: number;
      newColumn: number;
    }) => {
      return (await api.leadApi.changeLeadStatusColumn(leadId, newColumn)).data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: memberQueryKeys.all() });
      queryClient.invalidateQueries({
        queryKey: apiV2.staff.member.keys.all(),
      });
      queryClient.invalidateQueries({ queryKey: leadQueryKeys.all() });
      queryClient.invalidateQueries({ queryKey: reportQueryKeys.lead() });
    },
    ...mutationOpts,
  });

  return {
    changeLeadStatusMutation,
  };
}
